import type { CatalogProductCrossList, CatalogProductParam } from '~/modules/catalog/api'

/** Карточка списка всегда рисует фиксированное число строк — недостающие остаются пустыми */
export const CATALOG_CARD_SLOT_COUNT = 8

export const padCatalogCardSlots = <T,>(
  items: T[],
  slotCount: number = CATALOG_CARD_SLOT_COUNT
): (T | undefined)[] =>
  Array.from({ length: slotCount }, (_, idx) => items[idx])

export const getCatalogCardParamSlots = (
  params: CatalogProductParam[] | undefined
): (CatalogProductParam | undefined)[] =>
  padCatalogCardSlots(params ?? [])

export const getCatalogCardCrossListSlots = (
  crosslist: string[] | CatalogProductCrossList | undefined
): (string | undefined)[] => {
  const crosses = Array.isArray(crosslist) ? crosslist : []
  return padCatalogCardSlots(crosses)
}
